import { Component, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { AgRendererComponent } from 'ag-grid-angular';
import { MatDialog } from '@angular/material/dialog';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'mentor-select-user-lnk',
  template: `
    <input
      type="checkbox"
      [disabled]="!selectable"
      (click)="checkedHandler($event)"
      [checked]="params.value"
      id="chk_{{ params.data.id }}"
    />
  `,
  styles: [``],
})
export class SelectUserComponent implements OnDestroy, AgRendererComponent {
  params: any;
  selectable: boolean;
  id: number;

  constructor(public cService: CommonService, private dialog: MatDialog, private rptService: ReportsService) {}

  agInit(params: any): void {
    this.params = params;
    this.id = this.params.data.id;
    this.selectable = params.data.selectable;
  }

  checkedHandler(event) {
    let found = this.rptService.selectedRows.find((rp) => rp.id == this.id);
    let element = document.querySelector('#chk_' + this.id) as HTMLInputElement;
    if (found) {
      const index = this.rptService.selectedRows.indexOf(found);
      if (index > -1) {
        this.rptService.selectedRows.splice(index, 1);
      }
      element.checked = false;
    } else {
      if (this.selectable) {
        element.checked = true;
        this.rptService.selectedRows.push(this.params.data);
      }
    }

    this.params.data.selected = element.checked;

    let ct = this.rptService.selectedRows.length;
    let selectAll = document.querySelector('#checkAll') as HTMLInputElement;
    if (ct > 0) {
      selectAll.checked = false;
    }

    event.stopPropagation();
  }

  ngOnDestroy() {}

  refresh(params: any): boolean {
    return true;
  }
}
